import styled, { css } from 'styled-components';
import { containerMaxWidth, headingHeight } from '../../tokens';
import { themeable } from 'themes/utils';
import {
    notDesktopMediaQuery,
    showNotDesktopMixin,
    desktopMediaQuery,
    NotDesktopContainer
} from 'utils/mediaQuery';

import { ReactComponent as OpenMenuIcon } from './open-menu.svg';
import { FlexedContainer, HeadlineBase } from 'ui/Styled/Styled';
import { StyledButton } from 'ui/Button';

export const Container = styled.div<{ $flex?: boolean }>`
    display: flex;
    flex-flow: row;
    gap: 20px;
    box-sizing: border-box;
    max-width: ${containerMaxWidth};
    margin: 0 auto;

    ${desktopMediaQuery(css`
        padding: 20px;

        height: 100vh;
    `)}

    overflow: hidden;

    ${({ $flex }) =>
        notDesktopMediaQuery(
            $flex
                ? css`
                      height: 100dvh;
                  `
                : css`
                      padding-bottom: 20px;
                  `
        )}
`;

export const Main = styled.main`
    position: relative;
    box-sizing: border-box;
    overflow-x: hidden;
    display: flex;
    flex-flow: column;
    overflow-y: hidden;
    flex: 1;
    width: 100%;
    padding: 0 24px;
`;

export const Wrapper = styled.div`
    flex: 1;
    width: 100%;

    overflow-x: hidden;

    position: relative;

    ${desktopMediaQuery(css`
        overflow-x: hidden;
    `)}
`;

export const MainContainer = styled.div<{
    $disablePaddingTop?: boolean;
    $disableFlex?: boolean;
}>`
    position: relative;

    display: flex;
    flex-flow: column;
    width: 100%;
    background: ${themeable('mainBackgroundColor')};

    position: relative;

    height: 100%;

    ${desktopMediaQuery(css`
        padding-top: 43px;

        overflow-y: auto;
        border-radius: 16px;
    `)}

    ${({ $disableFlex }) =>
        $disableFlex &&
        css`
            display: block;
        `}

    ${({ $disablePaddingTop }) =>
        $disablePaddingTop &&
        desktopMediaQuery(css`
            padding-top: 0;

            & ${Main} {
                padding-top: 0;
            П}
        `)}

    ${notDesktopMediaQuery(css`
        padding-top: calc(${headingHeight} + 24px);
    `)}
`;

export const Heading = styled.header<{
    $disableMargin?: boolean;
    $wrap?: boolean;
}>`
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: 8px;
    z-index: 51;

    margin-bottom: 24px;

    ${({ $wrap }) =>
        $wrap &&
        css`
            padding: 0 24px;
        `}

    ${({ $disableMargin }) =>
        $disableMargin &&
        desktopMediaQuery(css`
            margin-bottom: 0;
        `)}

    ${desktopMediaQuery(css`
        /* align-items: flex-start; */
        gap: 16px;
    `)}

    ${notDesktopMediaQuery(css`
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        grid-template-columns: 52px 1fr 52px;
        padding: 4px 0;
        height: ${headingHeight};

        background: rgba(45, 48, 62, 0.5);
        backdrop-filter: blur(36px);

        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
    `)}
`;

export const Headline = styled(HeadlineBase)`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const OpenMenuButton = styled(OpenMenuIcon)`
    ${showNotDesktopMixin}
    width: 100%;
    height: auto;
    cursor: pointer;
    padding: 11px;
    width: 54px;
    box-sizing: border-box;
`;

export const OpenMenuButtonContainer = styled;

export const LogoContainer = styled(NotDesktopContainer)`
    margin: auto;
`;

export const HeadingRightContentContainer = styled(FlexedContainer)`
    display: flex;
    flex-flow: row;
    gap: 8px;
    justify-content: end;

    ${notDesktopMediaQuery(css`
        padding-right: 8px;

        & ${StyledButton} {
            min-width: unset;
            height: 40px;
        }
    `)}
`;
